!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("ati-ui-react/components/InputField")) : "function" == typeof define && define.amd ? define("ati-ui-react", ["react", "ati-ui-react/components/InputField"], t) : "object" == typeof exports ? exports["ati-ui-react"] = t(require("react"), require("ati-ui-react/components/InputField")) : e["ati-ui-react"] = t(e.React, e[void 0]);
}(this, function (n, r) {
  return u = {}, o.m = i = {
    0: function (e, t) {
      e.exports = n;
    },
    18: function (e, t) {
      e.exports = r;
    },
    646: function (e, t, n) {
      "use strict";

      n.r(t), n.d(t, "default", function () {
        return b;
      });
      var r = n(0),
        u = n.n(r),
        a = n(7),
        t = n(18),
        c = n.n(t);
      function o(e) {
        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function s() {
        return (s = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n,
              r = arguments[t];
            for (n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
          return e;
        }).apply(this, arguments);
      }
      function i(t, e) {
        var n,
          r = Object.keys(t);
        return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(t), e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n)), r;
      }
      function l(r) {
        for (var e = 1; e < arguments.length; e++) {
          var o = null != arguments[e] ? arguments[e] : {};
          e % 2 ? i(Object(o), !0).forEach(function (e) {
            var t, n;
            t = r, e = o[n = e], n in t ? Object.defineProperty(t, n, {
              value: e,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : t[n] = e;
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(o)) : i(Object(o)).forEach(function (e) {
            Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(o, e));
          });
        }
        return r;
      }
      function p(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      function f(e, t) {
        return (f = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }
      function d(n) {
        var r = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }();
        return function () {
          var e,
            t = y(n);
          return e = r ? (e = y(this).constructor, Reflect.construct(t, arguments, e)) : t.apply(this, arguments), t = this, !(e = e) || "object" !== o(e) && "function" != typeof e ? function (e) {
            if (void 0 !== e) return e;
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }(t) : e;
        };
      }
      function y(e) {
        return (y = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }
      var b = function () {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && f(e, t);
        }(i, r["PureComponent"]);
        var e,
          t,
          n,
          o = d(i);
        function i() {
          var n;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, i);
          for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) t[r] = arguments[r];
          return (n = o.call.apply(o, [this].concat(t))).getOnlyInputProps = function () {
            var e = l({}, n.props);
            return delete e.inputRestriction, delete e.onClear, delete e.focused, delete e.clearZeroOnBlur, delete e.maxDecimalPlaces, e;
          }, n.isRestricted = function (e, t) {
            switch (e) {
              case a.inputRestriction.numbersOnly:
                return /^\d*$/.test(t);
              case a.inputRestriction.nonNegativeFloat:
                return /^\d*(\.|,)?\d*$/.test(t);
              case a.inputRestriction.phoneNumber:
                return /^[\d ()+-]*$/.test(t);
              case a.inputRestriction.zeroTo9999Float:
                return RegExp("^(\\d{0,4}|\\d{1,4}[.,]\\d{0,".concat(n.props.maxDecimalPlaces, "})$")).test(t);
              case a.inputRestriction.zeroTo99Float:
                return RegExp("^(\\d{0,2}|\\d{1,2}[.,]\\d{0,".concat(n.props.maxDecimalPlaces, ")$")).test(t);
              case a.inputRestriction.zeroTo99:
                return /^(\d{0,2})$/.test(t);
              case a.inputRestriction.percents:
                return /^(\d{0,2}|100)$/.test(t);
              case a.inputRestriction.numbersWithSlash:
                return /^(\d*|\d+\/\d*)$/.test(t);
              case a.inputRestriction.nonNegativeFloatDecimalLimit:
                return RegExp("^\\d*(\\.|,)?\\d{0,".concat(n.props.maxDecimalPlaces, "}$")).test(t);
              default:
                return !0;
            }
          }, n.handleOnChange = function (e) {
            return n.isRestricted(n.props.inputRestriction, e.target.value) && e.target.value !== n.props.value ? "function" == typeof n.props.onChange && n.props.onChange(e, e.target.value) : (e.preventDefault(), e.stopPropagation()), !1;
          }, n.handleBlur = function (e) {
            n.props.clearZeroOnBlur && !+("" + n.props.value) && "function" == typeof n.props.onChange && n.props.onChange(null, null), "function" == typeof n.props.onBlur && n.props.onBlur(e);
          }, n;
        }
        return e = i, (t = [{
          key: "render",
          value: function () {
            var e = this.getOnlyInputProps();
            return e.disabled && (e.disabled = "disabled"), e.value || (e.value = ""), this.props.focused && (e.autoFocus = !0), u.a.createElement(c.a, s({}, e, {
              onBlur: this.handleBlur,
              onFocus: this.props.onFocus,
              onChange: this.handleOnChange
            }));
          }
        }]) && p(e.prototype, t), n && p(e, n), i;
      }();
      b.defaultProps = {
        maxDecimalPlaces: 3
      };
    },
    7: function (e, t, n) {
      "use strict";

      n.r(t), n.d(t, "errorPositions", function () {
        return r;
      }), n.d(t, "inputRestriction", function () {
        return o;
      }), n.d(t, "residences", function () {
        return i;
      }), n.d(t, "currencies", function () {
        return u;
      }), n.d(t, "individualOwnerships", function () {
        return a;
      }), n.d(t, "personalOwnerships", function () {
        return c;
      }), n.d(t, "individualOwnershipIds", function () {
        return s;
      }), n.d(t, "personalOwnershipIds", function () {
        return l;
      }), n.d(t, "requisiteTypeIds", function () {
        return p;
      }), n.d(t, "allContactsSelected", function () {
        return f;
      }), n.d(t, "commonBoardId", function () {
        return d;
      });
      var r = {
          bottom: "bottom",
          custom: "custom",
          right: "right",
          bottomRightAligned: "bottomRightAligned"
        },
        o = {
          none: 0,
          numbersOnly: 1,
          nonNegativeFloat: 2,
          phoneNumber: 3,
          zeroTo9999Float: 4,
          zeroTo99Float: 5,
          percents: 6,
          zeroTo99: 7,
          numbersWithSlash: 8,
          nonNegativeFloatDecimalLimit: 9
        },
        i = {
          russia: 0,
          ukraine: 1,
          kazakhstan: 2,
          other: 3,
          belorussia: 4,
          foreign: 5
        },
        u = {
          1: i.russia,
          2: i.other,
          3: i.other,
          5: i.ukraine,
          21: i.kazakhstan,
          22: i.belorussia
        },
        a = {
          IP: 4,
          PBOYUL: 7,
          PBOYUL2: 12,
          headOfFarm: 27,
          privateManufacturingEnterprise1: 39,
          privateManufacturingEnterprise2: 41
        },
        c = {
          personal: 25,
          personalEnterpreneur: 22
        },
        s = [4, 7, 12, 24, 27, 39, 40, 41],
        l = [25, 22, 76],
        p = {
          company: 1,
          individual: 6,
          natural: 3
        },
        f = "all_contacts",
        d = "a0a0a0a0a0a0a0a0a0a0a0a0";
    }
  }, o.c = u, o.d = function (e, t, n) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (t, e) {
    if (1 & e && (t = o(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var n = Object.create(null);
    if (o.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var r in t) o.d(n, r, function (e) {
      return t[e];
    }.bind(null, r));
    return n;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 646);
  function o(e) {
    if (u[e]) return u[e].exports;
    var t = u[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return i[e].call(t.exports, t, t.exports, o), t.l = !0, t.exports;
  }
  var i, u;
});